import { internalInstance } from '../http';

export const sendEmail = (requestData) =>
  internalInstance.post('/api/email', requestData);
export const sendEmailCheck = (requestData) =>
  internalInstance.get('/api/email/check', { params: requestData });
